export default function (state = {open: false,id: "0000"}, action) {
    switch (action.type) {
        case 'CANDIDATE_OPEN':
            return {
              open: action.open,
              id: action.candidate_id
            };
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/config/allReducers/dash/candidate.js